import React from 'react';
import styles from './styles.module.css';
import alert from 'V2/Shared/Assets/alert.svg';

import { ErrorBannerRedProps } from './types';

export const ErrorBannerRed: React.FC<ErrorBannerRedProps> = ({
  children,
  onClose,
  ...props
}) => {
  return (
    <div className={styles.errorBanner} {...props}>
      <div className={styles.alert}>
        <img src={alert} alt="alert" />
      </div>
      <div className={styles.message}>{children}</div>
      {onClose && (
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close error banner"
          type="button"
        >
          ×
        </button>
      )}
    </div>
  );
};
